define(["require", "exports", "jquery", "./context", "./dialogs/login", "./dialogs/emailMissing", "./dialogs/welcomeCredit", "./dialogs/signupCoupon"], function (require, exports, $, context_1, login_1, emailMissing_1, welcomeCredit_1, signupCoupon_1) {
    "use strict";
    exports.__esModule = true;
    var LoginStatus;
    (function (LoginStatus) {
        LoginStatus[LoginStatus["unknown"] = 0] = "unknown";
        LoginStatus[LoginStatus["not_authorized"] = 1] = "not_authorized";
        LoginStatus[LoginStatus["connected"] = 2] = "connected";
    })(LoginStatus = exports.LoginStatus || (exports.LoginStatus = {}));
    var authResponse = null;
    var logger = {
        debug: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                console.log.apply(console, args);
            }
            catch (ignored) {
            }
        }
    };
    function init(appId) {
        var deferred = $.Deferred();
        FB.init({
            appId: appId,
            cookie: true,
            xfbml: true,
            version: 'v2.5'
        });
        logger.debug('FB.init done');
        return deferred.resolve(true);
    }
    function getLoginStatus(deferred) {
        if (isCeluce()) {
            try {
                FB.getLoginStatus(function (resp) {
                    authResponse = resp;
                    if (resp) {
                        logger.debug("getLoginStatus = " + resp.status);
                        var status_1 = LoginStatus[resp.status];
                        deferred.resolve(status_1);
                    }
                    else {
                        logger.debug("getLoginStatus = undefined");
                        deferred.resolve(LoginStatus.unknown);
                    }
                });
            }
            catch (err) {
                logger.debug("getLoginStatus failed with " + JSON.stringify(err));
            }
        }
        else {
            logger.debug("getLoginStatus not celuce");
            deferred.resolve(LoginStatus.unknown);
        }
    }
    exports.getLoginStatus = getLoginStatus;
    function trackPageView() {
        FB.AppEvents.logPageView();
    }
    function isCeluce() {
        return window.location.hostname.toLowerCase().endsWith('celuce.com');
    }
    exports.isCeluce = isCeluce;
    function logIn() {
        var deferred = $.Deferred();
        if (authResponse && authResponse.authResponse && authResponse.authResponse.accessToken) {
            logger.debug('already logged in');
            deferred.resolve(authResponse);
        }
        else if (isCeluce()) {
            logger.debug('call FB.login');
            FB.login(function (resp) {
                logger.debug("login response status = " + resp.status);
                deferred.resolve(resp);
            }, { scope: 'email' });
        }
        else if (isLocalDev) {
            $.post('/Customer/LoginMockUser/5223364').then(function (x) {
                window.location.href = '/';
            });
        }
        else {
            deferred.reject('facebook login only works on www.celuce.com');
        }
        return deferred.promise();
    }
    exports.logIn = logIn;
    function logOut() {
        var deferred = $.Deferred();
        var statusDeferred = $.Deferred();
        getLoginStatus(statusDeferred);
        statusDeferred.then(function (status) {
            if (status == LoginStatus.connected) {
                FB.logout(function (resp) { authResponse = resp; deferred.resolve(true); });
            }
            else {
                deferred.resolve(false);
            }
        });
        return deferred.promise();
    }
    var showDialogOnLoadCookieName = 'showDialogOnLoad';
    function registerShowOnLoadDialog(dialog) {
        $.cookie(showDialogOnLoadCookieName, JSON.stringify(dialog), { path: '/' });
    }
    exports.registerShowOnLoadDialog = registerShowOnLoadDialog;
    function showOnLoadDialog() {
        var sd = $.cookie(showDialogOnLoadCookieName);
        if (sd) {
            $.removeCookie(showDialogOnLoadCookieName, { path: '/' });
            try {
                var dialog = JSON.parse(sd);
                var type = dialog.type, user = dialog.user;
                var coupon = user.coupon, email = user.email;
                if (user.isNewUser && user.email && user.firstName &&
                    type === 'welcomeCredit' &&
                    (user.credit || coupon && coupon.saving)) {
                    welcomeCredit_1["default"](dialog.user.firstName, dialog.user.credit, dialog.user.coupon);
                }
                else if (type === 'signupCoupon') {
                    var code = coupon.code, saving = coupon.saving, amount = coupon.amount;
                    if (code && saving && amount) {
                        signupCoupon_1["default"](code, saving, amount, email);
                    }
                }
            }
            catch (ex) {
                logger.debug("failed to showOnLoadDialog " + ex);
            }
        }
    }
    exports.showOnLoadDialog = showOnLoadDialog;
    function logInCeluce(thenActionName) {
        logger.debug('loginCeluce');
        return logIn().then(function (resp) {
            var authResponse = resp.authResponse;
            if (!authResponse || !authResponse.accessToken) {
                return $.Deferred().reject(new Error('fb login rejected'));
            }
            var token = authResponse.accessToken;
            var curPage = window.location.pathname.toLowerCase();
            if (curPage == '/login') {
                curPage = '/';
            }
            var $form = $('#loginAsFacebook');
            var action = $form.attr('action');
            var loginUrl = (isLocalDev ? 'http' : 'https') + "://" + window.location.host + action;
            $form.find('input[name="token"]').val(token);
            $form.find('input[name="returnUrl"]').val(curPage);
            return $.ajax({
                url: loginUrl,
                type: 'POST',
                data: $form.serialize(),
                dataType: 'json',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                }
            });
        })
            .then(function (resp) {
            if (resp.data) {
                if (thenActionName) {
                    var fn = window[thenActionName];
                    if (fn) {
                        fn();
                    }
                }
                else {
                    if (window.location.pathname === '/') {
                        var dialogType = 'welcomeCredit';
                        if (resp.user && resp.user.isNewUser && !resp.user.email) {
                            dialogType = 'emailMissing';
                        }
                        if (resp.user.credit && dialogType === 'welcomeCredit' || dialogType === 'emailMissing') {
                            registerShowOnLoadDialog({ type: dialogType, user: resp.user });
                        }
                        window.location.href = resp.data;
                    }
                }
            }
        })
            .fail(function (err) {
            emailMissing_1["default"]('mockUser', 'mockLastUser');
            logger.debug("facebook login failed with " + err);
        });
    }
    exports.logInCeluce = logInCeluce;
    $(function () {
        exports.fbInited = $.Deferred();
    });
    function initLogin(appId) {
        return init(appId).then(function () {
            var deferred = $.Deferred();
            getLoginStatus(deferred);
            return deferred.promise();
        }).then(function (status) {
            exports.fbInited.resolve(true);
            if (!context_1["default"].isUserLoggedIn()) {
                logger.debug("status = " + status);
                switch (status) {
                    case LoginStatus.connected:
                        logInCeluce();
                        break;
                    default:
                        $('.header-links a.ico-login, .header-links a.icon-head, a.header-links.icon-head').click(function (evt) {
                            logger.debug('login clicked');
                            evt.preventDefault();
                            evt.stopPropagation();
                            login_1["default"]();
                        });
                        break;
                }
            }
            else {
                $('.header-links a.ico-logout, .block-account-navigation a.logout').click(function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    logOut().then(function () {
                        window.location.href = '/logout';
                    });
                });
            }
            return $.Deferred().resolve(status);
        }, function (err) {
            exports.fbInited.resolve(false);
        });
    }
    exports.initLogin = initLogin;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/facebookApi.js
// module id = 8
// module chunks = 0